import { loadConfig } from './configLoader';
import type { AppConfig, Category } from './types';

let _config: AppConfig | null = null;

function waitForConfig<T>(selector: (cfg: AppConfig) => T): T | undefined {
  if (!_config) return undefined;
  return selector(_config);
}

export const brandStore = {
  async init(): Promise<void> {
    _config = await loadConfig();
  },
  get config(): AppConfig | null {
    return _config;
  },
  get primaryColor(): string {
    return waitForConfig((c) => c.brand.primaryColor) ?? '#7c6ef5';
  },
  get categories() {
    return waitForConfig((c) => c.categories) ?? [];
  },
  get api() {
    return waitForConfig((c) => c.api);
  },
  get labels() {
    return waitForConfig((c) => c.labels);
  },
  get theme() {
    return waitForConfig((c) => c.theme);
  },
  get arConfig() {
    return waitForConfig((c) => c.ar);
  },
  get pricing() {
    return waitForConfig((c) => c.pricing);
  },
  get model() {
    return waitForConfig((c) => c.model);
  },
  translateCategory(cat: string): string {
    return (
      waitForConfig((c) => c.categories.find((x: Category) => x.id === cat)?.label ?? cat) ?? cat
    );
  },
  getApiUrl(endpoint: string): string {
    const api = waitForConfig((c) => c.api);
    return (api?.baseUrl ?? '') + endpoint;
  },
};
